import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../redux/store";
import { setSignupData } from "../../../redux/signup";
import EditNickName from "../../../components/EditNickName";
import { GAEventNames, GACategoryName, GAUniqueEventIds } from "../../../helpers/Enums";
import { recordGaEvent } from "../../../helpers/GoogleAnalytics";

const SelectNicknameQuestion = (props: any) => {
    const dispatch = useDispatch();
    const register = useSelector((state: RootState) => state.signup);
    const question = useSelector((state: RootState) => state.signupQuestions.questions?.filter(x => x.questionId === 5));


    const onSave = (nickName: any) => {
        register.nickName = nickName;
        dispatch(setSignupData(register));
        props.next();

        recordGaEvent(GAEventNames.APP_SIGNUP, GACategoryName.SIGNING_STEPS, "step 6", "אישור שם", GAUniqueEventIds.APP_SIGNUP)

    };


    return (
        <>
            <EditNickName
                buttonText={"אפשר להמשיך"}
                subtitle={question && question[0].questionSubTitle}
                title={question && question[0].question}
                value={register.nickName} onSave={onSave} />
        </>
    )
}

export default SelectNicknameQuestion;